/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ClientBillingBackupFileConfiguration } from '../models/client-billing-backup-file-configuration';
import { ConfiguredClientList } from '../models/configured-client-list';
import { BackupFileColumn } from '../models/backup-file-column';
@Injectable({
  providedIn: 'root',
})
class ClientBillingBackupFileConfigurationService extends __BaseService {
  static readonly GetAllBackupFileConfigurationsPath = '/backupfileconfiguration';
  static readonly GetClientBackupFileConfigByAviClientIdPath = '/backupfileconfiguration/aviId/{aviClientId}';
  static readonly GetCustomsPath = '/backupfileconfiguration/customConfigClients';
  static readonly GetDefaultBackupFileConfigurationPath = '/backupfileconfiguration/defaultBackupFileConfiguration';
  static readonly PushClientBackUpConfigurationPath = '/backupfileconfiguration/pushBackupConfig';
  static readonly GetBackupFileCustomUsageFieldsPath = '/backupfileconfiguration/GetCustomUsageFields';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAllBackupFileConfigurationsResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<ClientBillingBackupFileConfiguration>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/backupfileconfiguration`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClientBillingBackupFileConfiguration>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAllBackupFileConfigurations(Authorization?: string): __Observable<Array<ClientBillingBackupFileConfiguration>> {
    return this.GetAllBackupFileConfigurationsResponse(Authorization).pipe(
      __map(_r => _r.body as Array<ClientBillingBackupFileConfiguration>)
    );
  }

  /**
   * @param params The `ClientBillingBackupFileConfigurationService.GetClientBackupFileConfigByAviClientIdParams` containing the following parameters:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetClientBackupFileConfigByAviClientIdResponse(params: ClientBillingBackupFileConfigurationService.GetClientBackupFileConfigByAviClientIdParams): __Observable<__StrictHttpResponse<ClientBillingBackupFileConfiguration>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/backupfileconfiguration/aviId/${params.aviClientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClientBillingBackupFileConfiguration>;
      })
    );
  }
  /**
   * @param params The `ClientBillingBackupFileConfigurationService.GetClientBackupFileConfigByAviClientIdParams` containing the following parameters:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetClientBackupFileConfigByAviClientId(params: ClientBillingBackupFileConfigurationService.GetClientBackupFileConfigByAviClientIdParams): __Observable<ClientBillingBackupFileConfiguration> {
    return this.GetClientBackupFileConfigByAviClientIdResponse(params).pipe(
      __map(_r => _r.body as ClientBillingBackupFileConfiguration)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetCustomsResponse(Authorization?: string): __Observable<__StrictHttpResponse<ConfiguredClientList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/backupfileconfiguration/customConfigClients`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ConfiguredClientList>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetCustoms(Authorization?: string): __Observable<ConfiguredClientList> {
    return this.GetCustomsResponse(Authorization).pipe(
      __map(_r => _r.body as ConfiguredClientList)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetDefaultBackupFileConfigurationResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<BackupFileColumn>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/backupfileconfiguration/defaultBackupFileConfiguration`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BackupFileColumn>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetDefaultBackupFileConfiguration(Authorization?: string): __Observable<Array<BackupFileColumn>> {
    return this.GetDefaultBackupFileConfigurationResponse(Authorization).pipe(
      __map(_r => _r.body as Array<BackupFileColumn>)
    );
  }

  /**
   * @param params The `ClientBillingBackupFileConfigurationService.PushClientBackUpConfigurationParams` containing the following parameters:
   *
   * - `backupConfig`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  PushClientBackUpConfigurationResponse(params: ClientBillingBackupFileConfigurationService.PushClientBackUpConfigurationParams): __Observable<__StrictHttpResponse<ClientBillingBackupFileConfiguration>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.backupConfig;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/backupfileconfiguration/pushBackupConfig`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClientBillingBackupFileConfiguration>;
      })
    );
  }
  /**
   * @param params The `ClientBillingBackupFileConfigurationService.PushClientBackUpConfigurationParams` containing the following parameters:
   *
   * - `backupConfig`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  PushClientBackUpConfiguration(params: ClientBillingBackupFileConfigurationService.PushClientBackUpConfigurationParams): __Observable<ClientBillingBackupFileConfiguration> {
    return this.PushClientBackUpConfigurationResponse(params).pipe(
      __map(_r => _r.body as ClientBillingBackupFileConfiguration)
    );
  }

  /**
   * @param params The `ClientBillingBackupFileConfigurationService.GetBackupFileCustomUsageFieldsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetBackupFileCustomUsageFieldsResponse(params: ClientBillingBackupFileConfigurationService.GetBackupFileCustomUsageFieldsParams): __Observable<__StrictHttpResponse<Array<BackupFileColumn>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.clientId != null) __params = __params.set('clientId', params.clientId.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/backupfileconfiguration/GetCustomUsageFields`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BackupFileColumn>>;
      })
    );
  }
  /**
   * @param params The `ClientBillingBackupFileConfigurationService.GetBackupFileCustomUsageFieldsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetBackupFileCustomUsageFields(params: ClientBillingBackupFileConfigurationService.GetBackupFileCustomUsageFieldsParams): __Observable<Array<BackupFileColumn>> {
    return this.GetBackupFileCustomUsageFieldsResponse(params).pipe(
      __map(_r => _r.body as Array<BackupFileColumn>)
    );
  }
}

module ClientBillingBackupFileConfigurationService {

  /**
   * Parameters for GetClientBackupFileConfigByAviClientId
   */
  export interface GetClientBackupFileConfigByAviClientIdParams {
    aviClientId: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for PushClientBackUpConfiguration
   */
  export interface PushClientBackUpConfigurationParams {
    backupConfig?: ClientBillingBackupFileConfiguration;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for GetBackupFileCustomUsageFields
   */
  export interface GetBackupFileCustomUsageFieldsParams {
    clientId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { ClientBillingBackupFileConfigurationService }
